<template>
    <v-dialog
        light
        v-model="show"
        width="500"
        class="modal-check-datamodel"
        :persistent="true"
    >
        <v-card>
            <v-card-title
                class="headline"
                primary-title
            >
                {{$t('instance.data_model.modal_check_datamodel.checking')}}
            </v-card-title>
            <v-card-text>
                <check-datamodel-status
                    ref="check-datamodel-status"
                    :scoped="false"
                    :onSuccess="onSuccess"
                    :onError="onError"
                ></check-datamodel-status>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    text
                    :disabled="disableCloseBtn"
                    @click="closeModal"
                >
                    {{$t('instance.data_model.modal_check_datamodel.close_btn')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import CheckDatamodelStatus from './check-datamodel-status.vue';
export default {
    components: {
        CheckDatamodelStatus,
    },

    props: {

    },

    data (){
        return {
            show: false,
            datamodel: null,
            disableCloseBtn: true,
        };
    },

    computed: {

    },

    mounted (){

    },

    methods: {
        open (datamodel, modelisationUid){
            this.show = true;
            this.$set(this, 'datamodel', datamodel);
            this.$store.dispatch('createItem', {
                item: {
                    value: datamodel,
                    modelisation_uid: modelisationUid,
                },
                model: 'importRequests',
                url: this.$store.state.api.meta.listModels.importRequests.url,
            }).then((response) => {
                this.$refs['check-datamodel-status'].startWatch(response.url);
            }).catch((e) => {
                console.error(e);
            });
        },
        onSuccess (response){
            this.disableCloseBtn = false;
            this.$emit('datamodel-imported-successfully', response.data.value);
        },
        onError (){
            this.disableCloseBtn = false;
        },
        closeModal (){
            this.$refs['check-datamodel-status'].resetData();
            this.show = false;
        }
    },
};
</script>

<style lang="scss">
    .modal-check-datamodel{
        min-height: 200px;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/modal-check-datamodel.vue